module.exports = __webpack_public_path__ + "static/media/bakesum_popup.359f571f.PNG";